{
  "CSAT": {
    "TITLE": "Califica tu conversación",
    "PLACEHOLDER": "Cuéntanos más...",
    "RATINGS": {
      "POOR": "😞 Pobre",
      "FAIR": "😑 Justo",
      "AVERAGE": "😐 Promedio",
      "GOOD": "😀 Bueno",
      "EXCELLENT": "😍 Excelente"
    }
  }
}
